* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

*::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

* {
  scrollbar-width: thin;
  scrollbar-color: var(--chart-104-pressed) var(--white-layout-302-level-1-elevation);
}
*::-webkit-scrollbar-track {
  background: var(--white-layout-302-level-1-elevation);
}
*::-webkit-scrollbar-thumb {
  background-color: var(--chart-104-pressed);
  border-radius: 6px;
}

.container {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-right: var(--spacer);
}

.content {
  overflow-y: auto;
  border-right: 1px solid var(--grey-layout-chart-100);
  height: 100%;
  margin: -10px;
  padding: 10px;
}

.list-title {
  color: var(--chart-302-icon-buttons-titles);
  min-height: calc(4 * var(--spacer));
  display: flex;
  align-items: center;
  margin-bottom: var(--spacer);
}

.list-unstyled {
  list-style: none;
  margin: 0;
  padding: 0;
  padding-bottom: var(--spacer);
  flex-grow: 1;

  li {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    min-height: calc(4 * var(--spacer));
    background-color: transparent;
    transition: background-color 0.3s ease-in-out;

    &:hover:not([disabled]),
    &.active {
      background-color: var(--blue-layout-050-selected);
      cursor: pointer;
    }
  }

  gz-checkbox {
    width: calc(2 * var(--spacer));
    height: calc(2 * var(--spacer));
    margin-right: var(--spacer);
  }

  .item-name {
    font-family: var(--font-family-secondary);
    font-size: var(--body-size-large);
    color: var(--main-titles-inputs-600);
  }
}

gz-progress-spinner {
  padding: calc(2 * var(--spacer)) 0;
  display: flex;
  justify-content: center;
  min-height: 64px;
}

.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
